// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__DjKWw","main":"Layout_main__wzvG5"};